module.exports = __webpack_public_path__ + "static/media/popup-panduan.e1a8fcbe.png";